import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Toast } from "bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";


const NotificationsToast = ({ show, data, onClose }) => {
  const toastRef = useRef(null);

  useEffect(() => {
    if (show && toastRef.current) {
      const bootstrapToast = new Toast(toastRef.current);
      // const bootstrapToast = new Toast(toastRef.current, {
      //   autohide: true,
      //   delay: 300000, // 5 minutes in milliseconds
      // });
      bootstrapToast.show();

      const element = toastRef.current;
      const handleHide = () => onClose(data.id);

      element.addEventListener("hidden.bs.toast", handleHide);

      return () => {
        element.removeEventListener("hidden.bs.toast", handleHide);
      };
    }
  }, [show, data, onClose]);

  if (!show) return null;

  console.log("data.bigPicture", data.bigPicture, data.message);

  return (
    <div
      className="position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 300000 }}
    >
      <div 
        className="toast fade show no-border-radius mb-2"
        ref={toastRef}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        {/* <div className="toast-header text-white success-toast">
                    <strong className="me-auto">Notification</strong>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                    ></button>
                </div> */}

      
              <div className="toast-body toast-body-notify d-flex justify-content-between align-items-center" >
                <div className="d-flex justify-content-between align-items-center">

                <div className="d-flex justify-content-start">
                   <img
                      src={data.bigPicture}
                      width={40}
                      height={40}
                      style={{
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                      alt="Profile Icon"
                    /> 
                </div>

                <div style={{ marginLeft: "5px" }}>
                  <small className="f-600">{data.message }  
                  </small>
                </div>
                </div>

                <div>          
                <CloseSharpIcon
                style={{fontSize: "18px", fontWeight:"600"}}
                                  className="pointer"
                                  onClick={() => {
                                   onClose()
                                  }}
                                />
                </div>
              </div>

      </div>
    </div>
  );
};

export default NotificationsToast;

